/**
 * Listening to variant changes and triggering event that eventually toggles variant spesific content visible.
 *
 * @since 2021-11-12
 * @author Approosters
 */
document.addEventListener('DOMContentLoaded', function(event) { 
  var forms = document.body.querySelectorAll('form.product-single__form');
  
  for (var i = 0; i < forms.length; i++) {
    var form = forms[i];
    
    form.addEventListener('change', function() {
      variant_changed(this, this.querySelector('[name="id"]').value);
    });
    
    form.addEventListener('approosters:variant-change', function(event) {
      var parent = this.closest('.product-single__meta');  
      var elems = parent.querySelectorAll('.selected-variant-data');

      for (var i = 0; i < elems.length; i++) {
        if (elems[i].getAttribute('data-variant-id') == this.getAttribute('data-current-variant-id')) {
          elems[i].style.display = null;
          elems[i].classList.remove('hide');
        }
        else {
          elems[i].style.display = 'none';
          elems[i].classList.add('hide');
        }
      }
  });
    
    variant_changed(form, form.querySelector('[name="id"]').value);
  }
});


function variant_changed(form, current_variant_id) {  
  console.log('[Approosters] Selected Variant: ' + current_variant_id);

  form.setAttribute('data-current-variant-id', current_variant_id);
  form.dispatchEvent(new CustomEvent('approosters:variant-change'));
  form.setAttribute('data-previous-variant-id', current_variant_id);
}
